import React, { useState } from 'react';

import MissionControlView from './MissionControl.view';
import moment from 'moment';
import { LayersTypes } from 'components/MapLayers/MapLayers.model';
import MapLayersHook from 'components/MapLayers/MapLayers.hook';

type Props = Record<never, never>;

const MissionControl: React.FC<Props> = () => {
  const { chargingPoints, powerTypeFilters, connectorTypeFilters, updatePowerTypeFilter, updateConnectorTypeFilter } = MapLayersHook();

  const [layerTypeState, setLayerTypeState] = useState<LayersTypes | null>(null);

  const [dateFiltersState, setDateFiltersState] = useState<{
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  }>({ startDate: moment(), endDate: moment() });

  const [generalFilterState, setGeneralFilterState] = useState<string>('');

  const initialDateFilter = {
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day'),
  };

  return (
    <MissionControlView
      powerTypeFilters={powerTypeFilters}
      onPowerTypeFilterChange={updatePowerTypeFilter}
      connectorTypeFilters={connectorTypeFilters}
      onConnectorTypeFilterChange={updateConnectorTypeFilter}
      onGeneralFilterChange={(event: React.ChangeEvent<HTMLInputElement>) => setGeneralFilterState(() => event.target.value)}
      generalFilterValue={generalFilterState}
      dateFilters={dateFiltersState}
      onDateFilterChange={(startDate: moment.Moment | null, endDate: moment.Moment | null) =>
        setDateFiltersState(() => {
          return { startDate, endDate };
        })
      }
      chargingPoints={chargingPoints}
      onClickLayer={(layer: LayersTypes | null) => setLayerTypeState(() => layer)}
      showLayerType={layerTypeState}
      onResetDate={() => setDateFiltersState(() => initialDateFilter)}
      onClearGeneralFilter={() => setGeneralFilterState(() => '')}
    ></MissionControlView>
  );
};

MissionControl.displayName = 'MisisonControl';

export default MissionControl;
